import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { DocumentType } from '~/db_types';
import BaseVue from '~/nasa_ui/base/BaseVue';
import { GENERAL_ENTITY_COLOR } from '~/nasa_ui/constants/colors';
import { AlertType, CosmicUserSupportContextDisplay, DocumentTypeDisplay, DocumentTypeLongDisplay, EntityType, UserPermission } from '~/nasa_ui/types';
import { currentSystemName } from '~/nasa_ui/utils/helpers/platform';
import { DEFAULT_DASH, STATIC_ASSETS_PATH } from '../constants';
import CurrentUserMixin from '../mixins/CurrentUserMixin';
let BaseCosmic = class BaseCosmic extends Mixins(BaseVue, CurrentUserMixin) {
    AlertType = AlertType;
    DocumentType = DocumentType;
    DocumentTypeDisplay = DocumentTypeDisplay;
    DocumentTypeLongDisplay = DocumentTypeLongDisplay;
    EntityType = EntityType;
    GENERAL_ENTITY_COLOR = GENERAL_ENTITY_COLOR;
    STATIC_ASSETS_PATH = STATIC_ASSETS_PATH;
    UserPermission = UserPermission;
    get currentSystemName() {
        return currentSystemName(this.$cosmicSystem);
    }
    copyToClipboard(whatToCopy) {
        navigator.clipboard.writeText(whatToCopy).then(() => {
            this.$notification.add({
                type: AlertType.SUCCESS,
                text: 'URL copied to clipboard!'
            });
        }, () => {
            this.$notification.add({
                type: AlertType.ERROR,
                text: 'Copy to clipboard failed.'
            });
        });
    }
    userSupportDisplay(organizationCode) {
        if (!organizationCode) {
            return DEFAULT_DASH;
        }
        return CosmicUserSupportContextDisplay.get(organizationCode) || DEFAULT_DASH;
    }
};
BaseCosmic = __decorate([
    Component
], BaseCosmic);
export default BaseCosmic;
